import Posthog from 'posthog-js';

export function captureEvent(event, attributes = {}) {
  Posthog.capture(event, attributes);
}

export function identifyUser(id, properties = {}) {
  Posthog.identify(id, properties);
}
